import store from '@/store'

/**
 * permitAll - permit no matter what access
 * anonymous - permit for user with no access (no login token)
 * privileges - permit if fulfill privileges (array - by default will check base on equals)
 */
export const checkAccess = ({ permitAll = false, anonymous = false, orCondition = false, privileges }) => {
  if (permitAll) {
    return true
  } else if (anonymous) {
    if (store.state.token.isLogin) {
      return false
    } else {
      return true
    }
  } else {
    if (privileges && privileges.length > 0) {
      return store.getters.checkAccess(privileges)
    } else {
      // no privileges stated. Default is as long as there is auth, we will permit
      if (store.state.token.isLogin) {
        return true
      } else {
        return false
      }
    }
  }
}
